import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer asm-modern-footer">
      <Container fluid={true}>
        <Row className="align-items-center gy-2">
          {/* Left Column: Brand copyright */}
          <Col md={6} sm={12} className="d-flex align-items-center">
            <span className="asm-footer-copy">
              © {currentYear} <span className="asm-footer-brand">Glogix</span>.
            </span>
          </Col>

          {/* Right Column: Design & Dev Credit */}
          <Col md={6} sm={12}>
            <div className="d-flex align-items-center justify-content-md-end justify-content-start">
              <div className="asm-footer-credit">
                <span>Design & Develop by</span>
                <Link to="#" className="asm-footer-credit-brand ms-1">
                  Glogix
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
